import { NextRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import * as process from 'process';
import qs from 'qs';

import { SubscribePlan } from '../../../types/SubscriptionType';

/**
 *  특정 첫글자만 대글자로 포맷으로 변경합니다.
 *  pro => Pro
 *  PRO => Pro
 *  Pro => Pro
 * */
export function capitalizeFirstLetter(
  str: string | Omit<SubscribePlan, 'free'>,
): string {
  const lowerCase = str.toLowerCase();

  return lowerCase.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
}

const PLAN_LEVEL: Partial<Record<string, number>> = {
  free: 0,
  basic: 1,
  pro: 2,
  enterprise: 3,
};

/** 대소문자 무관('PRO'·'pro'). 모르는 플랜은 -1. */
export const getSubscriptionPlanLevel = (plan: string) =>
  PLAN_LEVEL[plan.toLowerCase()] ?? -1;

const processIfQueryExists = (asPath: string) => {
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
  const url = new URL(asPath, baseUrl);

  if (url.search) {
    return `${baseUrl}${url.pathname}`;
  }
  return asPath;
};

export const makeRedirectUrl = (
  router: NextRouter,
  addQueryParams?: object,
) => {
  return `${processIfQueryExists(router.asPath)}?${qs.stringify({
    ...router.query,
    ...addQueryParams,
  })}`;
};

export const usePremiumOptionName = () => {
  const { t } = useTranslation(['subscription']);

  return {
    customUrl: t('subscription:pricing.pro.feature2', 'URL, 로고 커스터마이징'),
    googleAnalytics: t(
      'subscription:pricing.pro.feature4',
      'Google 애널리틱스 연동',
    ),
    dataDashboard: t(
      'subscription:pricing.enterprise.feature2',
      '데이터 대시보드 제공',
    ),
    premiumApp: t('subscription:pricing.pro.feature5', '무제한 앱 제공'),
    premiumPlanServer: t(
      'subscription:pricing.enterprise.feature3',
      '엔터프라이즈 전용 서버 할당',
    ),
    adPopupBlock: t(
      'subscription:pricing.basic.feature2',
      '스페이스 내 광고 팝업 제거',
    ),
  };
};
